import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {
  UserInfoConfigService,
  UserInfoConfig,
  SenderId,
  Organization,
  InviteUserRequest,
  Member, InviteResponse,
} from '@zikata-frontend/ui';
import { environment } from '../../../environments/environment';
import IZikataClientProfile from '../../models/user-profile-model';

@Injectable({
  providedIn: 'root',
})
export class ClientsPortalUserInfoConfigService extends UserInfoConfigService {
  constructor(private http: HttpClient) {
    super();
  }

  getConfig(): Observable<UserInfoConfig> {
    return of({
      showOrgs: true,
      showSenderIds: true,
      showBalance: true,
      showTopUpButton: true,
    });
  }

  getSenderIds(): Observable<SenderId[]> {
    const url = `${environment.apiGatewayBaseUrl}/sender/current/list`;
    return this.http.get<SenderId[]>(url);
  }

  getOrgs(): Observable<Organization[]> {
    const url = `${environment.apiGatewayV2BaseUrl}/organizations/me`;
    return this.http.get<Organization[]>(url);
  }

  deleteMember(orgId: string, userId: string): Observable<void> {
    const url = `${environment.apiGatewayV2BaseUrl}/organizations/${orgId}/members/${userId}`;
    return this.http.delete<void>(url, {});
  }

  toggleMember(orgId: string, userId: string): Observable<void> {
    const url = `${environment.apiGatewayV2BaseUrl}/organizations/${orgId}/toggle/${userId}`;
    return this.http.put<void>(url, {});
  }

  inviteUser(orgId: string, request: InviteUserRequest): Observable<any> {
    const url = `${environment.apiGatewayV2BaseUrl}/organizations/${orgId}/members/invite`;
    return this.http.post<void>(url, request);
  }

  getMemberRole(orgId: string, userId: string): Observable<Member> {
    const url = `${environment.apiGatewayV2BaseUrl}/organizations/${orgId}/members/${userId}/role`;
    return this.http.get<Member>(url);
  }

  updateMemberRole(
    orgId: string,
    userId: string,
    request: InviteUserRequest
  ): Observable<any> {
    const url = `${environment.apiGatewayV2BaseUrl}/organizations/${orgId}/members/${userId}/role`;
    return this.http.patch<void>(url, request);
  }

  getInvitedUsers(orgId: string): Observable<InviteResponse[]> {
    const url = `${environment.apiGatewayV2BaseUrl}/organizations/${orgId}/members/invites`;
    return this.http.get<InviteResponse[]>(url);
  }

  deleteInvite(orgId: string, inviteId: string): Observable<void> {
    const url = `${environment.apiGatewayV2BaseUrl}/organizations/${orgId}/members/invites/${inviteId}`;
    return this.http.delete<void>(url, {});
  }

  getBalance(senderId: string): Observable<number> {
    const url = `${environment.apiGatewayBaseUrl}/sender/balance/${senderId}`;
    return this.http.get<number>(url);
  }

  getUserAccount(): Observable<IZikataClientProfile> {
    const url = environment.apiGatewayBaseUrl + '/user/current';
    return this.http.get<IZikataClientProfile>(url);
  }
}
